import { api } from '@api'
import { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'

export type Message = {
  id: string
  content: string
  imageUrl: string | null
  author: {
    id: string
    avatarUrl: string | null
    fullName: string
  }
  createdAt: string
  updatedAt: string
}

const fetchMessages = async (
  conversationId: string,
  { pageParam = '0' }: FetchParams
): Promise<PaginatedResponse<Message>> => {
  const url = `/conversations/${conversationId}/messages?page=${pageParam}`
  
  const { data } = await api.get<PaginatedResponse<Message>>(url)
  return data
}

export const usePaginateMessages = (conversationId: string) => {
  return usePaginate<Message>(
    `messages-${conversationId}`,
    (params) => fetchMessages(conversationId, params)
  )
}

